import { combineReducers } from 'redux';
import { WidgetType } from 'widgets/WidgetType';
import { StrategyParametersWidgetState } from './StrategyParametersWidgetState';
import { StrategyParametersActionPayload } from './actions';
import { strategyParametersStreamReducer } from './stream/reducer';
import { createComponentStateReducer } from 'widgets/store/component/reducer';
import {
    initialStrategyParametersComponentState,
    StrategyParametersComponentState,
} from 'widgets/strategyParams/store/component/StrategyParametersComponentState';
import { createConfigurationReducer } from 'widgets/store/configuration/reducer';
import { StrategyParametersConfigurationState } from 'widgets/strategyParams/store/configuration/StrategyParametersConfigurationState';
import { createWidgetsReducer } from 'widgets/store/widgetsReducerFactory';

const widgetStateReducer = combineReducers<StrategyParametersWidgetState>({
    component: createComponentStateReducer<StrategyParametersComponentState>(
        initialStrategyParametersComponentState
    ),
    config: createConfigurationReducer<StrategyParametersConfigurationState>(
        {}
    ),
    stream: strategyParametersStreamReducer,
});

export const strategyParametersWidgetsReducer = createWidgetsReducer<
    StrategyParametersWidgetState,
    StrategyParametersActionPayload
>(WidgetType.STRATEGY_PARAMETERS, widgetStateReducer);
